
export const saveToLocalStorage = (key, value) => {
  if (key && value) {
    localStorage.setItem(key, value);
  }
};
